




































import { Component, Vue } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import { required, maxLength } from 'vuelidate/lib/validators';

const validIntentName = (value: string) => value.search(/[<>*%&:\\$]/) === -1;

@Component({
	mixins: [
		validationMixin,
	],
	validations: {
		intentTitle: {
			required,
			validIntentName,
			maxLength: maxLength(50)
		}
	}
})
export default class FaqAddIntentModal extends Vue {
	public show: boolean = false;

	public intentTitle: string = '';

	public showModal() {
		this.show = true;
		this.$nextTick(() => {
			this.focusOnInput();
		});
	}

	public close() {
		this.$v.$reset();
		this.show = false;
		this.intentTitle = '';
	}

	public createIntent() {
		if (this.$v.$invalid) {
			return;
		}
		this.$emit('create', this.intentTitle);
		this.close();
	}

	public getErrorMessage(): string {
		if (this.$v.intentTitle.required && !this.$v.intentTitle.validIntentName) {
			return 'Name must not contain <, >, *, %, &, :, \\, $';
		}
		if (!this.$v.intentTitle.maxLength) {
			return 'Name must not be longer than 50 characters';
		}
		if (!this.$v.intentTitle.required && this.$v.intentTitle.$dirty) {
			return 'Name must not be empty';
		}

		return '';
	}

	private focusOnInput() {
		const intentNameInput: any = this.$refs.intentNameInput;
		if (intentNameInput) {
			intentNameInput.focus();
		}
	}
}
